<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/181z6eB/tc-custom/9781504041447.jpg?1734199019480" alt="This image is the cover for the book Marietta Danver Trilogy, The Marietta Danver Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marietta Danver Trilogy, The Marietta Danver Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times</i>–bestselling historical trilogy of an eighteenth-century Englishwoman’s romances and adventures.</b><br/>  <br/> A great love story and a journey through the late eighteenth-century from England to colonial America to the Caribbean to imperial Russia, this trilogy by the author of <i>Angel in Scarlet</i> and other beloved historical romances follows Marietta Danver, a poor Englishwoman who escapes Newgate Prison to find a rich and passionate life.<br/>  <br/><i>Love’s Tender Fury</i>: Born out of wedlock to a London barmaid, Marietta Danver yearns to overcome her humble origins, but instead is sold into indentured servitude in North America. In the Carolinas and Louisiana, she will find herself arousing unruly passions in the hearts of three men.<br/>  <br/><i>Love Me, Marietta</i>: Marietta is engaged to a British aristocrat, but meets a rakish, indigo-eyed man in New Orleans she cannot help but feel drawn to. She will find herself reunited with him when she’s taken prisoner by pirates on the high seas.<br/>  <br/><i>When Love Commands</i>: Marietta awakens after a traumatic accident and finds herself in the care of a mesmerizingly handsome Russian count and his niece. But when she accompanies them to their lavish estate in St. Petersburg, she is caught up in the intrigues of the imperial court and must fight for her freedom—and her life.<br/>  <br/> Now available in one collection, this is a delicious read from one of the classic names in historical romance.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Wilde
      </h2>
      
      <p class="authorDescription body article">Jennifer Wilde is the pseudonym under which Tom E. Huff&#160;(1938&ndash;1990)&#160;wrote his groundbreaking <I>New York Times</I>&ndash;bestselling historical romance novels, including the Marietta Danver Trilogy (<I>Love&rsquo;s Tender Fury</I>,<I> Love Me, Marietta</I>,&#160;and<I>&#160;When Love Commands</I>). Huff also wrote classic Gothic romances as Edwina Marlow, Beatrice Parker, Katherine St. Clair, and T. E. Huff. A native of Texas who taught high school English before pursuing a career as a novelist, Huff was honored with a Career Achievement Award from&#160;<I>Romantic Times</I>&#160;in 1988.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d7d976e2